import * as React from 'react';
import { Environment } from '../../../../../remote-api/CoreServicesRemoteApi';
import Select from '@mulesoft/anypoint-components/lib/Select';
import './SettingsBodyEnvironmentSelector.css'

export type ValueProps = {
  environmentsLoading: boolean,
  environments?: Environment[],
  selectedEnvironment?: Environment,
}

export type EventProps = {
  onEnvironmentSelection: (result: any) => void
}

export type Props = ValueProps & EventProps

export const getEnvironmentsForSelection = (rawEnvironments?: Environment[]) => {
  const environments = rawEnvironments ? rawEnvironments : []
  return environments.map(env => ({value: env.id, label: env.name}))
}

export const getPlaceHolder = (environmentsForSelection: any[], environmentsLoading: boolean) => {
  if (environmentsLoading) {
    return 'Loading...'
  }
  
  return environmentsForSelection.length > 0 ? 'Select environment' : 'No environments found...'
}

export const SettingsBodyEnvironmentSelector = (props: Props) => {
  const {environmentsLoading, environments, selectedEnvironment} = props
  const resolvedEnvironments = getEnvironmentsForSelection(environments)
  const placeholder = getPlaceHolder(resolvedEnvironments, environmentsLoading)
  const value = selectedEnvironment && selectedEnvironment.id
  
  return (
    <div className="settings-body-environment-selector-container" data-test-id="settings-body-environment-selector-container">
      <div className="settings-body-environment-selector" data-test-id="settings-body-environment-selector">
        <span className="settings-body-environment-selector-label" data-test-id="settings-body-environment-selector-label">Environment</span>
        <Select
          name="settings-body-environment-select"
          className="settings-body-environment-select"
          testId="settings-body-environment-select"
          value={value}
          options={resolvedEnvironments}
          isLoading={environmentsLoading}
          placeholder={placeholder}
          onChange={props.onEnvironmentSelection}
        />
      </div>
    </div>
  )
}
